import { t } from "@lingui/core/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { HStack, Text } from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { useGetPackagePriceMap } from "@whoosh/features/src/Packages";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

import { PackagePriceDisplay_package$key } from "./__generated__/PackagePriceDisplay_package.graphql";

type Props = {
  packageRef?: PackagePriceDisplay_package$key | null;
};
export const PackagePriceDisplay = ({ packageRef }: Props) => {
  const { currencySymbol } = useGetClubCurrency();
  const pkg = useFragment(PackagePriceDisplayFragmentString, packageRef);

  const priceMap = useGetPackagePriceMap(pkg);

  return priceMap ? (
    <HStack alignItems="center">
      {priceMap["ONE_TIME"] !== undefined ? (
        <Text>
          {" "}
          {currencySymbol}
          {ConvertCentsToDollars(priceMap["ONE_TIME"])}
        </Text>
      ) : null}
      {priceMap["ONE_TIME"] && priceMap["MONTHLY"] ? (
        <Text>{t` + `}</Text>
      ) : null}

      {priceMap["MONTHLY"] !== undefined ? (
        <Text>
          {currencySymbol}
          {ConvertCentsToDollars(priceMap["MONTHLY"])}
          <Text color="text-secondary">{t` / month`}</Text>
        </Text>
      ) : null}
    </HStack>
  ) : null;
};

const PackagePriceDisplayFragmentString = graphql`
  fragment PackagePriceDisplay_package on Package {
    ...useGetPackagePriceMap_package
  }
`;
